import { fetchEndpointData } from '@utils/fetchEndpointData';

import type {
  CustomerPortalAccountRequestBody,
  CustomerPortalAccountRequestResponse,
} from './endpoints/CustomerPortalAccountRequestEndpoint.types';

export async function requestCustomerPortalAccount(
  data: CustomerPortalAccountRequestBody,
): Promise<CustomerPortalAccountRequestResponse> {
  return fetchEndpointData<CustomerPortalAccountRequestResponse>('/api/customer-portal/account-request', {
    method: 'POST',
    body: data,
  });
}
